<template>
  <div id="app" :style="{background: appBg}" v-loading="State.newPageLoading"  :class="{enLang: State.browserLanguage === 'en', zhLang: State.browserLanguage === 'zh'}">
    <router-view name="head"></router-view>
    <NetworkConnect v-show="!State.networkConnect"></NetworkConnect>
    <div class="contentBox">
      <router-view />
    </div>
  </div>
</template>
<script>
import Utils, { Tool } from '@/assets/js/utils.js'
import Websocket from '@/assets/js/websocket.js'
import { mapState } from 'vuex'
import Cookie from 'js-cookie'
import NetworkConnect from '@/components/common/network'
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'
import router from './router'

export default {
  name: 'App',
  components: {
    NetworkConnect
  },
  data () {
    return {
      appBg: ''
    }
  },
  async created () {
    // 生成clientId
    this.State.clientId = Math.random().toString(36).slice(2);
    // ga('create', Store.state.config.gaCode, 'auto')
    // ga('send', 'pageview')

    this.userId = await this.$store.dispatch('isLogin')
    if (this.userId) {
      this.initWebsocket()
    }
    await this.$store.dispatch('config')
    // HubSpot Embed Code. 中国区不加载，全球区加载
    if (!location.host.includes('cn')) {
      Tool.dynamicLoadJs('//js.hs-scripts.com/19963008.js', null, 'hs-script-loader')
    }
    // 集成sentry
    if (!location.host.includes('cn')) {
      if (process.env.NODE_ENV === 'production') {
        Sentry.init({
          Vue,
          dsn: 'https://***@***.ingest.sentry.io/***',
          beforeSend (event, hint) {
            const exception = hint.originalException
            if (exception && exception.__sentry_ignore__) {
              return null
            }
            if (exception?.message?.includes('Converting circular structure to JSON') &&
              event?.exception?.values?.[0]?.stacktrace?.frames?.some(f => f.filename?.includes('agora-rtc-sdk'))) {
              return null
            }
            return event
          },
          integrations: [
            new Integrations.BrowserTracing({
              routingInstrumentation: Sentry.vueRouterInstrumentation(router),
              tracingOrigins: ['localhost', 'local@tvunetworks.com', /^\//]
            })
          ],
          ignoreErrors: [
            /Network Error/i,
            /Request aborted/i,
            /NotAllowedError/i,
            /\b401\b/,
            /\b504\b/
          ],
          tracesSampleRate: 0.01,
          sampleRate: 0.05,
          logErrors: true,
          environment: this.$store.state.config.env || 'notObtainedEnv',
          release: localStorage.getItem('partylineCommentatorVersion')
        })
      }
    }
  },
  computed: {
    ...mapState({
      State: state => state
    })
  },
  watch: {
    '$route' (to, from) {
      if (to.name == 'leaveParty' || to.name === 'remove') {
        this.appBg = '#fff'
      } else {
        this.appBg = ''
      }
    }
  },
  methods: {
    // 初始化websocket
    initWebsocket () {
      const row = window.location.protocol === 'http' ? 'ws' : 'wss'
      if (!JSON.parse(localStorage.getItem('partylineCommentatorConfig')) || !JSON.parse(localStorage.getItem('partylineCommentatorConfig')).urlInfo) return
      const ccWebsocket = JSON.parse(
        localStorage.getItem('partylineCommentatorConfig')
      ).urlInfo.ccWebsocket
      const random32Str = Utils.getComRandomStr()
      const ws = new Websocket({
        url: `${row}://${ccWebsocket}/pageSerBusRequest?taskId=${random32Str}&businessId=${this.userId}&notCheckUser=true`,
        sendHeart: true,
        key: 'pageSerBusRequestByUseId'
      })
      ws.initWebSocket()
      this.$store.commit('setWebsocket', ws)
    }
  },
  mounted () {
    // if (Cookie.get('SID') && !window.location.href.includes('coordinationParticipate')) {
    //   NineSquared()
    // }
    this.$nextTick(() => {
      const language = Cookie.get('userLanguage') || 'en'
      this.State.browserLanguage = language
    })
  }
}
</script>

<style lang="less">
body {
  background: #0f0f0f;
  padding-right: 0px !important;
}
#app {
  &.enLang {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
    input, button {
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
    }
  }
  &.zhLang {
    font-family: PingFangSC,Microsoft Yahei,Helvetica,Arial,sans-serif;
    input, button {
      font-family: PingFangSC,Microsoft Yahei,Helvetica,Arial,sans-serif;
    }
  }
  background: #010101;
}
.contentBox {
  height: 100vh;
  padding-top:5px;
  background: #0f0f0f;
}
</style>
